import { create } from 'zustand';

/* ==========================================================================
   Recusa do servidor em tempo de execução (change whatsapp-channel, D30)

   A flag `panel.whatsapp-attendant` põe a loja no piloto, mas o servidor é
   quem decide: com `Whatsapp:Enabled=false`, com a flag desligada no
   backoffice com o painel aberto ou sem tenant, toda rota do Atendente IA
   (`/whatsapp/*` e, nas changes seguintes, `/customer-agent/*` e
   `/conversations`) responde 404 `whatsapp.disabled`. Quando isso chega, a
   aba, a faixa e o assistente somem sem esperar a próxima leitura de flags.

   O estado guarda de qual estabelecimento veio a recusa: trocar de loja volta
   a mostrar a área sem nenhum efeito de limpeza, porque quem pergunta compara
   com o tenant corrente. Mesmo molde da impressão.
   ========================================================================== */

interface CustomerAgentAvailabilityState {
  disabledTenantId: string | null;
  markDisabled: (tenantId: string) => void;
  clear: () => void;
}

export const useCustomerAgentAvailabilityStore = create<CustomerAgentAvailabilityState>((set) => ({
  disabledTenantId: null,
  markDisabled: (tenantId) => set({ disabledTenantId: tenantId }),
  clear: () => set({ disabledTenantId: null }),
}));

/** A API recusou com 404 `whatsapp.disabled`: a área do Atendente IA some para esta loja. */
export function markCustomerAgentDisabled(tenantId: string): void {
  if (tenantId) useCustomerAgentAvailabilityStore.getState().markDisabled(tenantId);
}
